import { isLocalMachine } from "../../utils/api/controlProxy";

const baseUrl = isLocalMachine() ? "/control" : "/d/control";

/**
 * Returns the endpoint URL for fnp cash balance.
 * @returns {string}
 */
export const GET_OCCASIONS_AND_TEMPLATE_MSGS = () => {
  return "/chocolate/v1/global/static/getoccasionsandtemplatemsgs";
};

/**
 * Returns the endpoint URL for fetching free message card details.
 */
export const GET_CARD_MESSAGE_DETAILS = (cartItemIndex) => {
  return `/control/getCardMessageDetails-rj?cartItemIndex=${cartItemIndex}`;
};
/**
 * Returns the endpoint URL for setting free message card details.
 */
export const SET_CARD_MESSAGE_DETAILS = () => {
  return `/control/setItemAttributesFromMobile`;
};

/**
 * Fetches the current sender's details.
 * @returns {string} The API endpoint for retrieving current sender information.
 */
export const GET_CURRENT_SENDER_DETAILS = () => {
  return "/control/getCurrentSenderInfo-rj";
};

/**
 * Fetches city suggestions based on a provided city hint.
 * @param {string} value - The city hint used to get search suggestions.
 * @returns {string} The API endpoint for retrieving suggested cities based on the city hint.
 */
export const GET_SEARCH_SUGGESTION_DETAILS = (value) => {
  return `/control/getSuggestedCities?cityHint=${value}`;
};
/**
 * Fetches the salutation lists.
 * @returns {string} The API endpoint for retrieving salutation list.
 */
export const GET_SALUTATION_DETAILS = () => {
  return `/control/getSalutaions-rj`;
};
/**
 * Fetches the Special country.
 * @returns {string} The API endpoint for retrieving Special country.
 */
export const GET_SPECIAL_COUNTRIES = () => {
  return `${baseUrl}/getSystemPropertyValue?defaultValue=N&name=ADDR_VALID_COUNTRY_GG&resource=fnp`;
};

/**
 * returns the endpoint URL for cart amount summary.
 */
export const GET_COUPON_LIST = () => {
  return "/control/getCoupons-rj";
};

/**
 * Returns the endpoint URL for fetching occasions and message templates.
 */
export const SET_ITEM_ATTRIBUTE_FOR_ORDER_ITEM = () => {
  return "/control/setItemAttributeForOrderItem";
};
/**
 * Sets attributes for a specific order item.
 * @returns {string} The API endpoint for setting item attributes for an order item.
 */
export const SET_ITEM_ATTRIBUTE_FOR_ADDRESS_FORM = () => {
  return `${baseUrl}/setAddressForItem-rj`;
};
/**
 * Sets attributes for a specific order item.
 * @returns {string} The API endpoint for setting item attributes for an order item.
 */
export const DELETE_ADDRESS_FORM_ITEM = (value) => {
  return `${baseUrl}/deleteItemAddress-rj?cartItemIndex=${value.cartItemIndex}&contactMechId=${value.contactMechId}`;
};
/**
 * Returns the endpoint URL for setting free message card details.
 */
export const APPLY_COUPON = () => {
  return `/control/applyCoupon-rj`;
};
/**
 * Returns the endpoint URL for removing already set free message card details.
 */
export const REMOVE_COUPON = () => {
  return `/control/removeCoupon-rj`;
};
/**
 * Returns the endpoint URL for fetching free message card details
 */
export const GET_CART_AMOUNT_SUMMARY_DETAILS = () => {
  return "/control/getCartSummaryAmountDetail-rj";
};

/**
 * Returns the endpoint URL for adding donate to cry
 */
export const ADD_DONATION_AMOUNT = (donationAmount) => {
  return `/control/addDonationAdjustmentToCart?amount=${donationAmount}`;
};

/**
 * Returns the endpoint URL for removing donate to cry
 */
export const REMOVE_DONATION_AMOUNT = (donationAmount) => {
  return `/control/removeDonationAdjustMent?amount=${donationAmount}`;
};

/**
 * Returns the endpoint URL for fetching donation status.
 */
export const GET_DONATION_STATUS = () => {
  return "/control/getSystemPropertyValue?name=enable.donation&resource=fnp";
};

/**
 * Returns the endpoint URL for fetching donation amount.
 */
export const GET_DONATION_AMOUNT = () => {
  return "/control/getSystemPropertyValue?name=donation.ammount&resource=fnp";
};

/**
 * Returns the endpoint URL for fetching carry bag amount.
 */
export const GET_CARRY_BAG_AMOUNT = () => {
  return "/control/getSystemPropertyValue?name=carryBag.amount&resource=fnp";
};
/**
 * Returns the endpoint URL for adding carry bag amount.
 */
export const ADD_CARRY_BAG_AMOUNT = (carryBagAmount) => {
  return `/control/addCarryBagAdjustmentToCart?amount=${carryBagAmount}`;
};
/**
 * Returns the endpoint URL for removing carry bag amount.
 */
export const REMOVE_CARRY_BAG_AMOUNT = (carryBagAmount) => {
  return `/control/removeCarryBagAdjustMent?amount=${carryBagAmount}`;
};
/**
 * return api end point for update cart
 */
export const SET_UPDATE_CART_FROM_DA_PAGE = () => {
  return "/control/updateCartFromDAPage-rj";
};
/**
 * Returns the endpoint URL for checking service availability for pincode.
 * @returns {string} The API endpoint for checking service availability for pincode.
 */
export const CHECK_SERVICE_AVAILABLE_FOR_PINCODE = () => {
  return "/serviceability/v1/products/serviceable";
};

/**
 * Returns the endpoint URL for fetching personalization details.
 * @param {string} orderItemSeqId - The order item sequence id.
 * @returns {string} The API endpoint for fetching personalization details.
 */
export const GET_PERSONALIZATION_DETAILS = (orderItemSeqId) => {
  return `/control/getPerOptForItem?orderItemSeqId=${orderItemSeqId}`;
};

/**
 * Returns the endpoint URL for resetting deliveries.
 * @returns {string} The API endpoint for resetting deliveries.
 */
export const RESET_DELIVERY = () => {
  return `/serviceability/v1/reset-deliveries`;
};

/**
 * Returns the endpoint URL for validating a map form address (location vs pincode).
 * @returns {string} The API endpoint for address validation.
 */
export const VALIDATE_ADDRESS = () => {
  return "/serviceability/v1/address/validate";
};

/**
 * Returns the endpoint URL for fetching product item quantity.
 * @returns {string} The API endpoint for fetching product item quantity.
 */
export const GET_PRODUCT_ITEM_QUANTITY = () => {
  return `/control/getSystemPropertyValue?resource=fnp&name=baseProduct.quantity.limit`;
};

/**
 * Returns the endpoint URL for sending OTP on the sender's mobile number.
 * @returns {string} The API endpoint for sending mobile OTP.
 */
export const SEND_MOBILE_OTP = () => {
  return "/control/sendMobileOTP";
};

/**
 * Returns the endpoint URL for validating the OTP sent on the sender's mobile number.
 * @returns {string} The API endpoint for validating mobile OTP.
 */
export const VALIDATE_MOBILE_OTP = () => {
  return "/control/validateMobileOtp";
};

/**
 * Returns the endpoint URL for setting user Clevertap session IDs.
 * @returns {string} The API endpoint for setting user Clevertap session IDs.
 */
export const PERSIST_ANALYTICS_SESSION_ID = () => {
  return `/control/persistPreOrderData-rj`;
};
